import api from './api';

class ComplaintService {
  async createComplaint(complaintData) {
    const formData = new FormData();

    formData.append('title', complaintData.title);
    formData.append('description', complaintData.description);
    formData.append('category', complaintData.category);
    formData.append('priority', complaintData.priority);
    formData.append('address', complaintData.address);

    formData.append(
      'location',
      JSON.stringify({
        latitude: complaintData.location.latitude,
        longitude: complaintData.location.longitude,
      })
    );

    if (complaintData.images && complaintData.images.length > 0) {
      complaintData.images.forEach((file) => {
        formData.append('images', file);
      });
    }

    const res = await api.post('/complaints', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  }

  async getComplaints(page = 1, limit = 50) {
    const res = await api.get(`/complaints?page=${page}&limit=${limit}`);
    return res.data;
  }

  async getComplaint(id) {
    const res = await api.get(`/complaints/${id}`);
    return res.data;
  }

  async submitFeedback(id, feedback) {
    const res = await api.post(`/complaints/${id}/feedback`, feedback);
    return res.data;
  }

  async updateStatus(id, data) {
    const formData = new FormData();
    if (data.status) formData.append('status', data.status);
    if (data.adminNotes) formData.append('adminNotes', data.adminNotes);

    if (data.afterImages && data.afterImages.length > 0) {
      data.afterImages.forEach((file) => {
        formData.append('afterImages', file);
      });
    }

    const res = await api.put(`/complaints/${id}/status`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  }

  async getAdminStats() {
    const res = await api.get('/admin/stats');
    return res.data;
  }

  async assignComplaint(id, assignedTo) {
    const res = await api.post(`/admin/complaints/${id}/assign`, {
      assignedTo,
    });
    return res.data;
  }
}

export default new ComplaintService();
